function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_4710",
  "data-name": "Rectangle 4710",
  width: 17.939,
  height: 15.553,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_24367",
  "data-name": "Group 24367",
  transform: "translate(1 -2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic-summary",
  transform: "translate(-1 2)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11466",
  "data-name": "Path 11466",
  d: "M14.637,16.2H1.039A1.04,1.04,0,0,1,0,15.166V6.638A1.04,1.04,0,0,1,1.039,5.6H6.281a.248.248,0,0,1,0,.5H1.039A.543.543,0,0,0,.5,6.638v8.527a.543.543,0,0,0,.543.543h13.6a.543.543,0,0,0,.543-.543V6.638a.543.543,0,0,0-.543-.543H12.753a.248.248,0,1,1,0-.5h1.884a1.039,1.039,0,0,1,1.038,1.038v8.527A1.04,1.04,0,0,1,14.637,16.2",
  transform: "translate(1.132 -3.51)",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11467",
  "data-name": "Path 11467",
  d: "M7.222,18.14H6.779c-.03,0-.055-.111-.055-.248V16.166c0-.137.024-.248.055-.248h.443c.03,0,.055.111.055.248v1.726c0,.137-.024.248-.055.248m-.388-.5h.333V16.414H6.834Z",
  transform: "translate(1.969 -3.719)",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11468",
  "data-name": "Path 11468",
  d: "M15.427,14.547H.248a.248.248,0,0,1,0-.5h15.18a.248.248,0,1,1,0,.5",
  transform: "translate(1.132 -3.681)",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11469",
  "data-name": "Path 11469",
  d: "M10.476,18.176H5.408a.248.248,0,1,1,0-.5h5.068a.248.248,0,1,1,0,.5",
  transform: "translate(1.027 -3.755)",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11472",
  "data-name": "Path 11472",
  d: "M12.234,9.246H4.316a.276.276,0,0,1,0-.551h7.918a.276.276,0,0,1,0,.551",
  transform: "translate(0.634 -0.854)",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11473",
  "data-name": "Path 11473",
  d: "M6.808,9.4H5.015a.256.256,0,0,1-.23-.276V7.208a.256.256,0,0,1,.23-.276H6.808a.256.256,0,0,1,.23.276V9.129a.256.256,0,0,1-.23.276M5.244,8.853H6.577V7.483H5.244Z",
  transform: "translate(1.085 -1.012)",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11474",
  "data-name": "Path 11474",
  d: "M9.048,9.51H7.02a.268.268,0,0,1-.26-.276V6.023a.268.268,0,0,1,.26-.276H9.048a.268.268,0,0,1,.26.276V9.235a.268.268,0,0,1-.26.276M7.28,8.959H8.788V6.3H7.28Z",
  transform: "translate(0.822 -1.119)",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11475",
  "data-name": "Path 11475",
  d: "M10.935,9.748H8.984a.263.263,0,0,1-.25-.276V3.839a.263.263,0,0,1,.25-.276h1.951a.264.264,0,0,1,.25.276V9.473a.264.264,0,0,1-.25.276M9.234,9.2h1.45V4.114H9.234Z",
  transform: "translate(0.959 -1.357)",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
})));

function SvgSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.939,
    height: 15.553,
    viewBox: "0 0 17.939 15.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.5638ae45.svg";
export { ForwardRef as ReactComponent };